<template><!-- 导入快录 -->
  <el-dialog
    :title="$t('receivablePayable.BatchImportClips')"
    :visible.sync="isBool"
    width="400px"
  >
    <div class="flex-c">
      <el-button
        icon="el-icon-download"
        size="small"
        type="primary"
        :loading="loading"
        style="margin: 0 10px 10px 0"
        @click="DownloadTemplate"
      >{{ $t('receivablePayable.DownloadTheTemplate') }}</el-button>
      <upload-excel
        :on-success="importLogistics"
        :but-name="$t('receivablePayable.BatchImportClips')"
      />
    </div>
  </el-dialog>
</template>

<script>
import uploadExcel from '@/components/UploadExcel';
import { saveAs } from 'file-saver';
import ExcelJS from 'exceljs';
import { goFileUploadManagement } from '@/utils/goExportList.js';
import {
  apiPayableSiteExpenseBatchFastInputFee
} from '@/api/finance/receivables';
import i18n from '@/lang';
import { isValidDateTime } from '@/views/finance/payableManage/feesPayable/utils';

// 1安骏小屋，2第三方揽收，3AJD派送, 4DSP派送, 5运输干支线 6 邮局派送
const titleMap = {
  1: i18n.t('receivablePayable.AnjunCottage'), // 安俊
  2: i18n.t('receivablePayable.ThirdPartyCollection'), // 第三方
  3: i18n.t('receivablePayable.AJDDispatch'), // AJD
  4: i18n.t('receivablePayable.DSPDispatch'), // DSP
  6: i18n.t('receivablePayable.postOfficeDelivery') // 邮局派送
};

export default {
  name: 'ImportQuickRecording',

  components: {
    uploadExcel
  },
  props: {
    // 网点列表
    outletsList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 操作人列表
    operatorList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 费用列表
    feeTypeList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 服务商下拉
    providerChannelList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // 账单类型
    payableType: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      isBool: false
    };
  },
  methods: {
    open() {
      this.isBool = true;
    },
    // 下载模板
    async DownloadTemplate() {
      const that = this;
      async function ddd() {
        const wb = new ExcelJS.Workbook();
        const Sheet1 = wb.addWorksheet('Sheet1');
        const Sheet2 = wb.addWorksheet('Sheet2'); // 网点
        const Sheet3 = wb.addWorksheet('Sheet3'); // 业务类型
        const Sheet4 = wb.addWorksheet('Sheet4'); // 揽收方式
        const Sheet5 = wb.addWorksheet('Sheet5'); // 运营模式
        const Sheet6 = wb.addWorksheet('Sheet6'); // 费用类型
        const Sheet7 = wb.addWorksheet('Sheet7'); // 操作人
        const Sheet8 = wb.addWorksheet('Sheet8'); // 服务商渠道

        // 列定义
        const columns = [
          { header: '业务单号' + '(QR)', key: 'waybillNumber', width: 40 },
          { header: '客户', key: 'customerName', width: 40 },
          { header: '网点', key: 'siteId', width: 40 },
          { header: '计费重量', key: 'chargeWeight', width: 40 },
          { header: '费用类型', key: 'feeCode', width: 40 },
          { header: '应付金额', key: 'fee', width: 40 },
          { header: '业务时间(格式：2022-01-01 00:00:00)', key: 'operateTime', width: 80 },
          { header: '操作人(员工账户名)', key: 'operator', width: 40 },
          { header: '备注', key: 'remark', width: 40 }
        ];
        // 安骏
        const columns1 = [
          { header: '揽收方式', key: 'collectType', width: 40 },
          { header: '运营模式', key: 'operationMode', width: 40 }
        ];
        if (that.payableType === 1) {
          columns.splice(4, 0, ...columns1);
        }
        // 第三方
        const columns2 = [
          { header: '业务类型', key: 'orderBusinessType', width: 40 }
        ];
        if (that.payableType === 2) {
          columns.splice(4, 0, ...columns2, ...columns1);
        }
        // 邮局
        const columns3 = [
          { header: '服务商渠道', key: 'providerChannelId', width: 60 }
        ];
        if (that.payableType === 6) {
          columns.splice(4, 0, ...columns3);
        }

        Sheet1.columns = columns;

        // 国际化字符串配置
        const translations = {
          pt: {
            waybillNumber: 'número do negócio(QR)',
            customerName: 'cliente',
            siteId: 'Ponto de rede',
            chargeWeight: 'Peso faturável',
            orderBusinessType: 'Tipo de área',
            collectType: 'maneira de coleta',
            operationMode: 'Modelo de operação',
            providerChannelId: 'Canais de provedor de serviços',
            feeCode: 'Tipo de custo',
            fee: 'Valor a Pagar',
            operateTime: 'Hora da ocorrência (Formato: 2022-01-01 00:00:00)',
            operator: 'Pessoa de poeração',
            remark: 'Observações'
          }
        };

        // 动态生成列标题
        try {
          const setTranslatedHeaders = (sheet, headers) => {
            headers.forEach((header, index) => {
              const cell = sheet.getCell(`${String.fromCharCode(65 + index)}2`);
              cell.value = header;
            });
          };

          const translatedHeaders = columns.map(col => translations.pt[col.key]);
          setTranslatedHeaders(Sheet1, translatedHeaders);
        } catch (error) {
          console.error('Error setting translated headers:', error);
        }

        Sheet1.mergeCells('A3:K3');
        Sheet1.getCell('A3').value = `1、每次仅导入 100000 条 /Importar apenas 100000 itens de cada vez
          2、除了备注其他必填 /Tudo, exceto as notas, é obrigatório
          3、不可更改此模板 /Esse modelo não pode ser alterado '`;
        Sheet1.getRow(3).getCell(1).font = {
          color: { argb: 'ff0000' }
        };

        console.log(columns);
        // 数据填充
        // 工具函数：填充 sheet 数据
        const fillSheet = (sheet, headerKey, dataList, labelProp, valueProp) => {
          sheet.columns = [{ header: that.$t(headerKey), key: 'value', width: 40 }];
          const data = (dataList || []).map(item => ({ value: item[labelProp] + '-' + item[valueProp] }));
          sheet.addRows(data);
        };

        fillSheet(Sheet2, 'basicData.Outlets', that.outletsList, 'name', 'id'); // 网点
        fillSheet(Sheet6, 'basicData.ExpenseType', that.feeTypeList, 'displayName', 'code'); // 费用类型

        Sheet3.columns = [{
          header: that.$t('collectionCenter.businessT'), // 业务类型
          key: 'orderBusinessType',
          width: 40
        }];
        Sheet3.addRows([
          { orderBusinessType: that.$t('basicData.CourierSystemBusiness') + '-1' },
          { orderBusinessType: that.$t('basicData.CollectionSystemBusiness') + '-0' }
        ]);

        Sheet4.columns = [{
          header: that.$t('collectionCenter.lanshouTypee'), // 揽收方式
          key: 'collectType',
          width: 40
        }];
        Sheet4.addRows([
          { collectType: that.$t('collectionCenter.dropOff') + '-1' },
          { collectType: that.$t('collectionCenter.doorPickUp') + '-2' }
        ]);

        Sheet5.columns = [{
          header: that.$t('collectionCenter.operationMode'), // 运营模式
          key: 'operationMode',
          width: 40
        }];
        Sheet5.addRows([
          { operationMode: that.$t('collectionCenter.directOperation') + '-0' },
          { operationMode: that.$t('collectionCenter.thirdPartyCooperation') + '-1' }
        ]);

        // fillSheet(Sheet7, 'basicData.Operator', that.operatorList, 'username', 'id'); // 操作员
        // Sheet7 - 操作人
        Sheet7.columns = [{ header: that.$t('basicData.Operator'), key: 'operator', width: 40 }];
        const Sheet7_data = that.operatorList.map(item => ({
          operator: that.payableType === 3 ? item.deliveryManName + '-' + item.supplierId : item.username + '-' + item.id
        }));
        Sheet7.addRows(Sheet7_data);

        // Sheet8 - 服务商渠道
        Sheet8.columns = [{ header: that.$t('GlobalSetObj.ServiceProviderChannels'), key: 'providerChannelId', width: 60 }];
        const Sheet8_data = that.providerChannelList.map(item => ({ providerChannelId: item.providerChannelName + '-' + item.id }));
        Sheet8.addRows(Sheet8_data);

        // 数据绑定（默认生成100）
        const setDataValidation = (sheet, row, col, refSheet, dataList) => {
          sheet.getCell(row, col).dataValidation = {
            type: 'list',
            formulae: [`=${refSheet}!$A$2:$A${(dataList || []).length + 1}`]
          };
        };

        console.log(Sheet2);
        new Array(100).fill(0).forEach((_, idx) => {
          const row = idx + 3;

          // 网点下拉框
          setDataValidation(Sheet1, row, 3, 'Sheet2', that.outletsList);

          if (that.payableType === 1) {
            setDataValidation(Sheet1, row, 5, 'Sheet4', Sheet4.getRows(2, 2)); // 揽收方式
            setDataValidation(Sheet1, row, 6, 'Sheet5', Sheet5.getRows(2, 2)); // 运营模式
            setDataValidation(Sheet1, row, 7, 'Sheet6', that.feeTypeList); // 费用类型
            setDataValidation(Sheet1, row, 10, 'Sheet7', Sheet7_data); // 操作人
            Sheet1.getCell(row, 9).numFmt = '@'; // 业务时间
          } else if (that.payableType === 2) {
            setDataValidation(Sheet1, row, 5, 'Sheet3', Sheet3.getRows(2, 2)); // 业务类型
            setDataValidation(Sheet1, row, 6, 'Sheet4', Sheet4.getRows(2, 2)); // 揽收方式
            setDataValidation(Sheet1, row, 7, 'Sheet5', Sheet5.getRows(2, 2)); // 运营模式
            setDataValidation(Sheet1, row, 8, 'Sheet6', that.feeTypeList); // 费用类型
            setDataValidation(Sheet1, row, 11, 'Sheet7', Sheet7_data); // 操作人
            Sheet1.getCell(row, 10).numFmt = '@'; // 业务时间
          } else if (that.payableType === 6) {
            setDataValidation(Sheet1, row, 5, 'Sheet8', Sheet8_data); // 费用类型
            setDataValidation(Sheet1, row, 6, 'Sheet6', that.feeTypeList); // 费用类型
            setDataValidation(Sheet1, row, 9, 'Sheet7', Sheet7_data); // 操作人
            Sheet1.getCell(row, 8).numFmt = '@'; // 业务时间
          } else {
            setDataValidation(Sheet1, row, 5, 'Sheet6', that.feeTypeList); // 费用类型
            setDataValidation(Sheet1, row, 8, 'Sheet7', Sheet7_data); // 操作人
            Sheet1.getCell(row, 7).numFmt = '@'; // 业务时间
          }
        });

        const buffer = await wb.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/octet-stream' });
        const saveName = that.setFileName();
        saveAs(blob, saveName);
      }
      try {
        await ddd();
      } catch (error) {
        console.error(error);
      }
    },

    // 导入
    async importLogistics(importData) {
      const importList = importData[0].results.splice(2); // 解析数据
      console.log(importList, 'excel数据');
      const herderObj = {
        '业务单号(QR)': 'waybillNumber',
        '客户': 'customerName',
        '计费重量': 'chargeWeight',
        '应付金额': 'fee',
        '业务时间(格式：2022-01-01 00:00:00)': 'operateTime',
        '备注': 'remark'
      };
      const headConfig = {
        '网点': 'siteId',
        '业务类型': 'orderBusinessType',
        '揽收方式': 'collectType',
        '运营模式': 'operationMode',
        '费用类型': 'feeCode',
        '操作人(员工账户名)': 'operator',
        '服务商渠道': 'providerChannelId'
      };
      const dataList = [];
      importList.map((item, index) => {
        const data = {};
        console.log(item, 'item');
        try {
          Object.keys(item).forEach((key, i) => {
            // console.log(key, i);
            // 需要映射的key
            if (headConfig[key]) {
              data[headConfig[key]] = item[key]?.split('-').pop() || '';
            } else {
              if (key === '业务时间(格式：2022-01-01 00:00:00)') {
                // const dateTimePattern = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
                // if (!dateTimePattern.test(item[key])) {
                if (!isValidDateTime(item[key])) {
                  const rowInfo = this.$t('basicData.row') + (index + 1) + this.$t('basicData.line');
                  const errorMsg = this.$t('receivablePayable.BusinessTimeFormatError');
                  throw new Error(`${rowInfo} ${errorMsg}: ${item[key]}`);
                }
                data[herderObj[key]] = item[key];
              } else {
                data[herderObj[key]] = item[key] || '';
              }
            }
          });
        } catch (error) {
          this.$message.error(error.message);
          throw error;
        }
        console.log(data);
        dataList.push(data);
      });
      console.log(dataList, '解析后数据');
      const list = dataList.map(item => {
        item.businessType = [1, 2].includes(this.payableType) ? 2 : 3;
        return item;
      });
      // return;
      try {
        const res = await apiPayableSiteExpenseBatchFastInputFee({
          list: list,
          payableType: this.payableType
        });
        if (res.code === 200) {
          await goFileUploadManagement(this);
          this.isBool = false;
        }
      } catch (error) {
        console.error('导入费用时发生错误:', error);
      }
    },

    // 设定模板名称
    setFileName() {
      const name = titleMap[this.payableType];
      return name + this.$t('receivablePayable.BatchImportClips') + '.xlsx';
    }
  }
};
</script>

<style scoped>
.flex-c {
  display: flex;
  flex-wrap: wrap;
}
</style>
